import { FC } from 'react'
import { twMerge } from '@lib/tailwind-merge'

export const ActiveDiamond: FC<{
  active: boolean
  className?: string
  size?: 'sm' | 'md'
}> = ({ active, className, size = 'sm' }) => {
  return (
    <div
      className={twMerge(
        'rotate-45',
        size === 'sm' && 'w-2 h-2',
        size === 'md' && 'w-[10px] h-[10px]',
        active && 'bg-success-500',
        !active && 'border border-neutral-400',
        className,
      )}
    ></div>
  )
}
